module.exports = __webpack_public_path__ + "img/titleMy.acd61682.png";